<template>
  <div>
    <v-form>
      <v-layout row wrap>

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">{{$t('Buying-Invoice-Information')}}</span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm4 md4>
                    <v-text-field hide-details="" v-model="val.FaturaBilgileri.AlisFaturaNo" maxlength="10" mask="##########" :label="$t('Buying-Invoice-No')"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>

                    <tarihim :etiket="$t('Buying-Invoice-Date')" v-bind:defaultvalue="'no'" v-bind:value="val.FaturaBilgileri.AlisFaturaTarihi"
                      v-model="val.FaturaBilgileri.AlisFaturaTarihi"></tarihim>
                  </v-flex>

                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">{{$t('Private-Ticket-Description')}}</span>
            </v-card-title>
          </v-card>
        </v-flex>


        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.EmployeeId" :label="$t('Employee-ID')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.DepartmentId" :label="$t('Depart-No')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.CostCenter" :label="$t('Cost-Center')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.ClientId" :label="$t('Client-ID')"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.DkNumber" :label="$t('DK-Number')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.WwId" :label="$t('WW-ID')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.BusinessUnit" :label="$t('Business-Unit')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.CompanyCode" :label="$t('Company-No')"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.SiteCode" :label="$t('Site-Code')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.PurposeOt" :label="$t('Purpose-OT')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.PcNumber" :label="$t('PC-Number')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.NoHotelBc" :label="$t('NO-Hotel-BC')"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.ExAciklamalar.TripApprover" :label="$t('Trip-Approver')"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row="" wrap="">

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium ">  {{ $t('MIL-Code') }} </span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.MilKodu.MilKoduOde" :label="$t('MIL-Code') + ' ('+ $t('Paid-by') +')-1'"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.MilKodu.MilKoduYolcu" :label="$t('MIL-Code') + ' ( '+ $t('Passenger') +') '"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" type="Number" v-model="val.TanimBilgileri.MilKodu.MilAdet" :label="$t('MIL-Number')"></v-text-field>
                  <parainput :isPositive="true" :simge="getparabirimi()"  :etiket="$t('MIL-Amount')" v-model="val.TanimBilgileri.MilKodu.MilTutar" :autocomplete="'autocomplete'"></parainput>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>


        <v-layout row="" wrap="">


        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium "> {{ $t('Ticket-Description') }} </span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama1" label="1"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama2" label="2"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama3" label="3"></v-text-field>
                </v-layout>
           </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama4" label="4"></v-text-field>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama5" label="5"></v-text-field>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama6" label="6"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>            
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.Aciklamalar.Aciklama7" label="7"></v-text-field>
                </v-layout>
            </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>    

        </v-layout>

        <v-layout row="" wrap="">
        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium "> {{ $t('Identitynumber_label') }} </span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>           
                <v-layout justify-space-between column>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo1" :label="$t('Identitynumber_label') + ' ('+ $t('Passenger') +')'"></v-text-field>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo2" :label="$t('Identitynumber_label') + ' (' + $t('Paid-by') + ' ) '"></v-text-field>
                   <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo3" :label="$t('Identitynumber_label') + '(' +$t('Person-Offering-Booking') + ')'"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>            
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo4" :label="$t('Identitynumber_label') + ' (Extra 1) '"></v-text-field>
                  <v-text-field hide-details="" v-model="val.TanimBilgileri.TcKimlikNolar.TcNo5" :label="$t('Identitynumber_label') + ' (Extra 2) '"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
          <!-- <div class="flex md1">
            <v-btn color="info" @click.native="tcdialog = true"> {{ $t('New') }}
              <v-icon>add</v-icon>
            </v-btn>
          </div> -->
        </v-layout>

        <v-layout row="" wrap="">

        <v-flex xs12 sm12 md12>
          <v-card flat="" color="#9E9E9E">
            <v-card-title>
              <span class="subheading white--text font-weight-medium "> {{ $t('Detailed-Ticket-Information') }} </span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>
                <v-layout justify-space-between column>
                 <v-text-field hide-details="" mask="NNNNNNNNNNNNNNNNNNNNNNNN" v-model="val.NotlarBilgileri.MarketCode"
                  label="Market Code"></v-text-field>
                  <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.TicketSuffix" :label="$t('Ticket-No-Suffix')"></v-text-field>
                  <v-text-field hide-details="" mask="NNNNNNNNNNN" v-model="val.NotlarBilgileri.VendorNumber" :label="$t('Wendor-Number')"></v-text-field>
                  <v-text-field hide-details="" mask="NN" v-model="val.NotlarBilgileri.ReasonCode" :label="$t('Reason-Code')"></v-text-field>
                  <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.CRSGDS" label="CRS-GDS"></v-text-field>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4 md4 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>                 
                <v-layout justify-space-between column>
                  <v-text-field hide-details="" mask="NNN" v-model="val.NotlarBilgileri.SubPruductCode" :label="$t('Sub-Product-Code')"></v-text-field>
                  <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Tour Code" v-model="val.NotlarBilgileri.TourCode"></v-text-field>
                  <v-checkbox label="Ticket Type Indicator" v-model="val.NotlarBilgileri.TicketTypeInd" hide-details=""></v-checkbox>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>
    </v-layout>
    </v-form>
  </div>
</template>

<script>
  import parainput from '@/components/app/customcomp/parainput.vue'
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    props: ["value"],
    components: {
      parainput,
      tarihim
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },

    data() {
      return {

      }
    },

    watch: {

    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },

    },

  }
</script>